import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronRight, Loader2 } from "lucide-react";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { SettingsMetaPage } from "./SettingsMetaPageLayout";

export function SettingsMetaBusinessRoute() {
  const { businessId } = useParams<{ businessId: string }>();
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchBusiness() {
      if (!businessId) return;

      setIsLoading(true);
      try {
        const response = await fetch(`/api/meta/businesses/${businessId}`);
        if (response.ok) {
          const data = await response.json();
          const businessName = data.business?.name || businessId;
          setBreadcrumbs([
            { label: "Settings", path: "/settings" },
            { label: "Integrations", path: "/settings/integrations" },
            { label: "Meta", path: "/settings/integrations/meta" },
            { label: businessName, path: `/settings/meta/businesses/${businessId}` },
          ]);
        } else {
          setBreadcrumbs([
            { label: "Settings", path: "/settings" },
            { label: "Integrations", path: "/settings/integrations" },
            { label: "Meta", path: "/settings/integrations/meta" },
            { label: businessId, path: `/settings/meta/businesses/${businessId}` },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch Meta business:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchBusiness();

    return () => {
      clearBreadcrumbs();
    };
  }, [businessId]);

  if (isLoading) {
    return (
      <SettingsMetaPage className="flex justify-center items-center min-h-[40vh]">
        <Loader2 className="animate-spin h-12 w-12 text-muted-foreground" />
      </SettingsMetaPage>
    );
  }

  return (
    <SettingsMetaPage>
      <Link
        to={`/settings/meta/businesses/${businessId}/ad-accounts`}
        className="flex items-center justify-between border rounded-lg p-4 hover:bg-muted/50 transition-colors"
      >
        <span className="font-medium">Ad Accounts</span>
        <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
      </Link>
    </SettingsMetaPage>
  );
}
